import storageData from './shared/state';

export default {
  ...storageData,
};
